import { IsNotEmpty, IsIn, IsNumber, IsOptional } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IAgilityScore } from "./agility-score.interface";

export class AgilityScoreDto implements IAgilityScore {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @IsOptional()
  @IsNumber()
  score?: number;

  @IsOptional()
  @IsNumber()
  time?: number;

  @IsOptional()
  @IsNumber()
  points?: number;

  @IsOptional()
  @IsNumber()
  faults?: number;

  @IsOptional()
  @IsNumber()
  time_faults?: number;

  @IsOptional()
  @IsNumber()
  act?: number;

  @IsOptional()
  excluded_from_placement?: boolean;
}
